<template>
  <div style="margin: 25px">
    <b-button
      style="margin-bottom: 15px"
      variant="success"
      @click="openConfirm()"
    >
      <span class="align-middle">Yeni Ekle</span>
    </b-button>
    <vue-good-table
      :columns="alternatiflercolumns"
      :rows="alternatiflerList"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-row>
              <b-col lg="12" sm="12">
                <vs-button
                  @click="
                    alternatifSil(props.row.STOCKID, props.row.STOCKIDALTER)
                  "
                  color="danger"
                  type="flat"
                  size="small"
                  icon="delete_forever"
                ></vs-button>
              </b-col>
            </b-row>
          </span>
        </span>
      </template>

      <!-- pagination -->
    </vue-good-table>

    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Seçin"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <div>
                <vue-autosuggest
                  v-model="query"
                  style="width: 100%; padding: 5px; height: 200px"
                  :suggestions="filteredOptions"
                  :get-suggestion-value="getSuggestionValue"
                  :input-props="{
                    id: 'autosuggest__input',
                    class: 'form-control',
                    placeholder: 'Stok Kodu / Stok Adı',
                  }"
                  @input="onInputChange"
                  :sectionConfigs="sectionConfigs"
                >
                  <template slot-scope="{ suggestion }">
                    <div class="d-flex align-items-center my-suggestion-item">
                      <div class="detail ml-50 my-suggestion-item">
                        <b-card-text class="mb-0">
                          {{ suggestion.item.STOCKNO }} /
                          {{ suggestion.item.A }}
                        </b-card-text>
                      </div>
                    </div>
                  </template>
                </vue-autosuggest>
              </div>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="lg"
            class="float-right"
            @click="cancel()"
          >
            İptal
          </b-button>
          <b-button
            style="margin-right: 25px"
            :disabled="isDisabled"
            size="lg"
            variant="success"
            class="float-right"
            @click="alternatifEkle()"
          >
            Ekle
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { VueAutosuggest } from "vue-autosuggest";
import { BModal, BButton, VBModal } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  data() {
    return {
      isDisabled: true,
      sectionConfigs: {
        A: {
          limit: 6,
          label: "Stok Adı",
        },
      },
      query: "",
      selected: "",
      stokIdSecilen: "",
      filteredOptions: [],
      valMultipe: {
        value1: "",
      },
      datasuggest: [],
      activePrompt: false,
      dir: false,

      alternatiflercolumns: [
        {
          label: "Stok No",
          field: "STOCKNOALTER",
        },
        {
          label: "Stok Adı",
          field: "STOCKNAMEALTER",
        },
        {
          label: "Depo Adet",
          field: "STOCKIDALTERQREM",
        },
        {
          label: "Alım Siparişi",
          field: "SATALSIP",
        },
        {
          label: "Satış Siparişi",
          field: "SATSIP",
        },
        {
          label: "Çıkış Mik",
          field: "CIKIS",
        },
        {
          label: "Satış Fiyatı",
          field: "SATISFIYAT",
        },
        {
          label: "Net Alış Fiyatı",
          field: "NETALIS",
        },
        {
          field: "action",
        },
      ],
      alternatiflerList: [],
    };
  },
  components: {
    "vue-autosuggest": VueAutosuggest,
    BButton,
    BModal,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    cancel() {
      this.stokIdSecilen = "";
      this.$refs["modal-primary "].hide();
    },
    getSuggestionValue(suggestion) {
      this.stokIdSecilen = suggestion.item.STOCKID;
      // if(suggestion)
      this.isDisabled = false;
      return suggestion.item.STOCKNO + " / " + suggestion.item.A;
    },
    onInputChange(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ARANAN: text,
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_StokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_StokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Stock_StokSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter((option) => {
                return (
                  option.A.toLowerCase().indexOf(vm.query.toLowerCase()) > -1 ||
                  option.STOCKNO.toLowerCase().indexOf(vm.query.toLowerCase()) >
                    -1
                );
              }),
            },
          ];
        });
      });
    },
    openConfirm() {
      this.$refs["modal-primary "].show();
    },
    alternatifSil(stokId, stokIdAlter) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        STOCKID: stokId,
        STOCKIDALTER: stokIdAlter,
        ISLEM: "DELETE",
      };

      soap.createClient(url, function (err, client) {
        client.INT_Stock_AlternatifIslem(args, function (err, result) {
          if (result.INT_Stock_AlternatifIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Stock_AlternatifIslemResult);
            vm.alternatifler();
            //  vm.datasuggest = vm.veriler;
          } catch (error) {
            console.log(result);
            vm.alternatifler();
          }
        });
      });
    },
    alternatifEkle() {
      const vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
        STOCKIDALTER: vm.stokIdSecilen,
        ISLEM: "INSERT",
      };

      soap.createClient(url, function (err, client) {
        client.INT_Stock_AlternatifIslem(args, function (err, result) {
          if (result.INT_Stock_AlternatifIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Stock_AlternatifIslemResult);
            vm.alternatifler();
            vm.$refs["modal-primary "].hide();

            //  vm.datasuggest = vm.veriler;
          } catch (error) {
            console.log(result);
            vm.alternatifler();
          }
        });
      });
      vm.query = "";
    },
    alternatifler() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockEktsre_Alternatif(args, function (err, result) {
          if (result.INT_Ls_StockEktsre_AlternatifResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_StockEktsre_AlternatifResult);
            vm.alternatiflerList = vm.veriler;
            // vm.rowData = vm.veriler;
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
    stokList(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ARANAN: text,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_StokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_StokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_Stock_StokSecResult);
            vm.datasuggest = vm.veriler;
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
  },

  created() {
    this.stokList();
    this.alternatifler();
  },
};
</script>
<style lang="scss">
.vuesax-app-is-ltr .con-vs-dialog {
  left: 0;
  z-index: 1000000000000000000000000000000 !important;
}
[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>

